import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { shopApi, shopError } from "../lib/shop";

const Ctx = createContext(null);

export function CustomerAuthProvider({ children }) {
    const [customer, setCustomer] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await shopApi.get("/auth/me");
            setCustomer(data);
        } catch {
            setCustomer(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // CRM / legacy admin screens never carry a customer session — skip the 401 noise.
        if (window.location.pathname.startsWith("/rhm") || window.location.pathname.startsWith("/admin")) {
            setLoading(false);
            return;
        }
        refresh();
    }, [refresh]);

    const register = async (payload) => {
        try {
            const { data } = await shopApi.post("/auth/register", payload);
            localStorage.setItem("rhm_customer_token", data.token);
            setCustomer(data.customer);
            return { ok: true };
        } catch (e) {
            return { ok: false, error: shopError(e) };
        }
    };

    const login = async (email, password) => {
        try {
            const { data } = await shopApi.post("/auth/login", { email, password });
            localStorage.setItem("rhm_customer_token", data.token);
            setCustomer(data.customer);
            return { ok: true };
        } catch (e) {
            return { ok: false, error: shopError(e) };
        }
    };

    const logout = async () => {
        try { await shopApi.post("/auth/logout"); } catch { /* ignore */ }
        localStorage.removeItem("rhm_customer_token");
        setCustomer(null);
    };

    const loginWithGoogle = async () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUri = `${window.location.origin}/auth/google`;
        const next = window.location.pathname.startsWith("/auth/") ? "/account" : window.location.pathname;
        const { data } = await shopApi.post("/auth/google/start", { redirect_uri: redirectUri, next });
        window.location.href = data.url;
    };

    return (
        <Ctx.Provider value={{ customer, loading, register, login, logout, loginWithGoogle, refresh, setCustomer }}>
            {children}
        </Ctx.Provider>
    );
}

export const useCustomerAuth = () => useContext(Ctx);
